module.exports = __webpack_public_path__ + "static/media/kota.57354e09.svg";